import { normalizeOrganizationId } from "@/shared/organizations/organization-id";
import { INVITATIONS_PAGE_SIZE } from "./constants";
import type { InvitationRole, InvitationStatus } from "./types";

export interface InvitationsFilters {
  readonly status: InvitationStatus | null;
  readonly role: InvitationRole | null;
  readonly organizationId: string;
}

export const EMPTY_INVITATION_FILTERS: InvitationsFilters = {
  status: null,
  role: null,
  organizationId: "",
};

export interface InvitationsListParams extends InvitationsFilters {
  readonly page: number;
}

export function hasActiveFilters(filters: InvitationsFilters): boolean {
  return (
    filters.status !== null ||
    filters.role !== null ||
    normalizeOrganizationId(filters.organizationId) !== null
  );
}

/**
 * Query string for `GET /api/admin/invitations`. There is deliberately NO
 * email parameter: the invitee address is PII and request URLs land in access
 * logs the GDPR erasure flow cannot purge (the API rejects it as well).
 */
export function buildInvitationsQuery(params: InvitationsListParams): string {
  const search = new URLSearchParams();
  search.set("page", String(Math.max(1, Math.floor(params.page))));
  search.set("limit", String(INVITATIONS_PAGE_SIZE));
  if (params.status) search.set("status", params.status);
  if (params.role) search.set("role", params.role);
  const organizationId = normalizeOrganizationId(params.organizationId);
  if (organizationId) search.set("organizationId", organizationId);
  return `?${search.toString()}`;
}
